import axios from "axios";

/**
 * True when a request failed because the flow session's access token is no
 * longer valid. Polling loops must treat this as terminal rather than
 * transient: nothing refreshes the token mid-step, so retrying can only spin
 * forever.
 */
const isAuthError = (error: unknown): boolean =>
  axios.isAxiosError(error) && error.response?.status === 401;

export default isAuthError;
